import ActionTypes from '../constants/ActionTypes';

// eslint-disable-next-line import/prefer-default-export
export const fetchActions = (sellitemId) => ({
  type: ActionTypes.ACTIONS_FETCH,
  payload: {
    sellitemId,
  },
});

fetchActions.success = (sellitemId, actions, users) => ({
  type: ActionTypes.ACTIONS_FETCH__SUCCESS,
  payload: {
    sellitemId,
    actions,
    users,
  },
});

fetchActions.failure = (sellitemId, error) => ({
  type: ActionTypes.ACTIONS_FETCH__FAILURE,
  payload: {
    sellitemId,
    error,
  },
});
